import { useTranslation } from 'react-i18next';
import { ButtonPrimary } from '@components/button';
import { CloseButton } from '@components/close-button';

export const AdmissionDeleteSoldItemsModal = ({
  handleClose,
  handleClick,
}: {
  handleClick: () => void;
  handleClose: () => void;
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <div className='flex justify-end m-6'>
        <CloseButton handleClose={handleClose} />
      </div>
      <div className='flex flex-col items-center mx-8 mb-8'>
        <p className='text-primary text-subtitle-l text-center'>{t('offers:admissionDeleteSoldItemsTitle')}</p>
        <p className='mt-3 text-primary text-body-m text-center'>{t('offers:admissionDeleteSoldItemsDescription')}</p>
        <ButtonPrimary className='mt-7' onClick={handleClick}>
          {t('offers:admissionDeleteSoldItemsHideOffer')}
        </ButtonPrimary>
      </div>
    </div>
  );
};
